const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the Top Five directive to display a list of the 5 most Viewed, or Liked, or Shared contents
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 * @argument {Resource} Analyze the resource defined to get Analyze data
 * @argument {Resource} Overview the resource defined to get Overview view data
 */
app.directive('topFive', ['Application', 'AdminContent', 'Analyze', 'Overview', '$translate', function (Application, AdminContent, Analyze, Overview, $translate) {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        for : '@',
        of: '=?'
      },
      template: require('../../../templates/directives/overview/top-five.html'),
      controller: ['$scope', function ($scope) {
          var self = this;
          self.getError = Application.notifications.getError;
          self.getSuccess = Application.notifications.getSuccess;
          self.header = 'Header';
          self.icon = 'Icon';
          self.subresource = {};
          self.links = [];
          self.typeLink = {
            article: 'articles',
            video: 'videos',
            file: 'files',
            track: 'tracks',
            scorm: 'scorm',
            imported_content: 'imported-content',
            presentation: 'presentations',
            workshop: 'workshops',
            multi_session_workshop: 'multi-session-workshops',
            assessment: 'assessments'
          };
          $translate(['modules.topFive.mostViewed', 'modules.topFive.mostViewedContent', 'modules.topFive.mostLiked', 'modules.topFive.mostLikedContent', 'modules.topFive.mostModified', 'modules.topFive.mostModifiedContent', 'modules.topFive.mostShared', 'modules.topFive.mostSharedContent']).then(function (translations) {
            self.labels = translations;
            self.initialize();
          });
          self.initialize = function () {
            self.subresource.subresource = $scope.for.toLowerCase();
            self.icon = self.subresource.subresource.slice(0, -1);
            switch (self.subresource.subresource) {
              case 'views':
                self.header = self.labels['modules.topFive.mostViewedContent'] + ' ' + ($scope.of ? $scope.of : '');
                break;
              case 'modifications':
                self.header = self.labels['modules.topFive.mostModifiedContent'] + ' ' + ($scope.of ? $scope.of : '');
                break;
              case 'shares':
                self.header = self.labels['modules.topFive.mostSharedContent'] + ' ' + ($scope.of ? $scope.of : '');
                break
              case 'likes':
                self.header = self.labels['modules.topFive.mostLikedContent'] + ' ' + ($scope.of ? $scope.of : '');
                break;
              case 'added':
                self.header = 'Recently Added Content';
                break;
              default:
                console.log('Unknown for/subresource attribute ', $scope.for);
            }
            if ($scope.of) {
              var type = $scope.of.toLowerCase().slice(0, -1);
              if (type === 'quizze') {
                type = 'quiz';
              }
              self.subresource.type = type;
              self.subresource.content_type = type;
            }

            if (self.subresource.subresource !== 'added') {
              Analyze.top5(self.subresource, function (unresolved_items) {
                Overview.resolve({}, {unresolved: unresolved_items}, function (resolved_items) {
                  angular.forEach(resolved_items, function (resolved_item) {
                    $translate('topfive.been_removed', { type : (resolved_item.content_type || resolved_item.type) }).then(function(translations){
                      var link = {label: (resolved_item.title || translations), link: '#/view/' + (self.typeLink[resolved_item.content_type] || self.typeLink[resolved_item.type]) + '/' + resolved_item._id};
                      self.links.push(link);
                    });

                  });
                }, function (error) {
                  console.log('Error resolving items:', error);
                  angular.forEach(unresolved_items, function (datum) {
                    $translate('topfive.been_removed',{ type : (datum.content_type || datum.type) }).then(function(translations){
                      var link = {label: translations, link: '#/view/' + (self.typeLink[datum.content_type] || self.typeLink[datum.type]) + '/' + datum._id};
                      self.links.push(link);
                    });
                  });
                });
              }, function (error) {
                console.log('Error getting top5:', error);
              });
              return;
            }

            AdminContent.findAnalytics({
              page: 1,
              per_page: 5,
              sort: 'updatedAt,-1',
              types: 'articles,videos,files,tracks,scorm,imported-content,presentations,workshops'
            }).$promise
            .then(function(results) {

              var content = results.data;
              var sortField = 'createdAt';

              content.sort(function(a, b) {
                if (!b[sortField] || !a[sortField]) {
                  return b[sortField] - a[sortField];
                }
                return new Date(b[sortField]) - new Date(a[sortField]);
              });

              content.slice(0, 5).forEach(function(item) {
                $translate('topfive.been_removed', { type : (item.content_type || item.type) }).then(function(translations){
                  var type = (item.content_type || item.type);
                  var link = {label: (item.title || translations), link: '#/view/' + self.typeLink[type] + '/' + item._id};
                  self.links.push(link);
                });
              });

            }, function(error) {
              console.log('Error getting content:', error);
            });

          };
        }],
      controllerAs: 'top'
    };
  }]);
